import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import glamorous from 'glamorous'
import { startDDCCall, endDDCCall } from '../../actions/send'
import {
  track3ds2PageStartDDC,
  isFireAndForget,
} from 'transfer/utils/3ds-utils'
import { get } from 'lodash'

const Iframe = glamorous.iframe({
  display: 'none',
})

/**
 * This component makes a DDC call for 3DS2.0 if there is a
 * Device Data Collection Contingency on any of the funding options returned by funding-options API
 */
export class DeviceDataCollection extends React.Component {
  static propTypes = {
    isGuest: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    fireDDC: PropTypes.bool,
    ddcCalls: PropTypes.array,
    jwt: PropTypes.string,
    deviceDataCollectionUrl: PropTypes.string,
    threeDS2ReferenceId: PropTypes.string,
  }

  /**
   * In case the props are updated, submit the form which is a POST call to DDC
   */

  static defaultProps = {
    isGuest: false,
    ddcCalls: [],
  }

  /**
   * In case the props are updated, submit the form which is a POST call to DDC
   */
  componentDidMount() {
    const { fireDDC, isGuest } = this.props
    if (fireDDC && isGuest) {
      const formElement = this.refs[this.props.threeDS2ReferenceId]
      if (formElement) {
        formElement.submit()
      }
    }
    window.addEventListener('message', this.cardinalEventHandler)
  }

  cardinalEventHandler = event => {
    const { dispatch, ddcCalls } = this.props

    // This handler is only used for fire and forget
    if (!isFireAndForget(ddcCalls)) {
      return
    }

    if (event.origin && event.origin.includes('cardinalcommerce.com')) {
      let data = null
      try {
        data = JSON.parse(event.data)
      } catch (exception) {
        // Error handler incase parsing goes wrong
        data = {}
      }
      if (get(data, 'MessageType', '') === 'profile.completed') {
        dispatch(endDDCCall())
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { threeDS2ReferenceId, fireDDC, ddcCalls = [], dispatch } = this.props

    if (fireDDC && threeDS2ReferenceId) {
      const formElement = this.refs[threeDS2ReferenceId]
      if (formElement) {
        formElement.submit()
      }
    }

    /**
     * FireDDC in Background without interrupting user experience ,
     * sequentially till the ddcCalls array is empty
     * After each DDC call is complete, we remove the ddc contingency from the array
     *
     * Only used in the fire and forget variant
     */
    if (isFireAndForget(ddcCalls) && !fireDDC && ddcCalls.length > 0) {
      const ddcInfo = ddcCalls[0]
      // Adding a small delay of 100ms as sometimes the immediate sequential calls are failing
      setTimeout(() => {
        track3ds2PageStartDDC(ddcInfo)
        dispatch(startDDCCall(ddcInfo))
      }, 500)
    }
  }

  componentWillUnmount() {
    const { threeDS2ReferenceId } = this.props
    if (threeDS2ReferenceId) {
      this.refs[threeDS2ReferenceId] = null
    }
    window.removeEventListener('message', this.cardinalEventHandler)
  }

  render() {
    const {
      deviceDataCollectionUrl = '',
      jwt = '',
      threeDS2ReferenceId = '',
    } = this.props

    // Do not render component if no threeDS2ReferenceId
    if (!threeDS2ReferenceId) {
      return null
    }
    return (
      <div>
        <Iframe height="1" width="1" name="deviceData" id="deviceData" />
        <form
          ref={threeDS2ReferenceId}
          method="POST"
          name="deviceData"
          target="deviceData"
          action={deviceDataCollectionUrl}
        >
          <input type="hidden" name="JWT" data-testid="jwt" value={jwt} />
        </form>
      </div>
    )
  }
}

export default connect(({ transaction }) => ({
  fireDDC: transaction.fireDDC,
  ddcCalls: transaction.ddcCalls,
  jwt: transaction.ddcJWT,
  deviceDataCollectionUrl: transaction.deviceDataCollectionUrl,
  threeDS2ReferenceId: transaction.threeDS2ReferenceId,
}))(DeviceDataCollection)
